<template>
  <v-dialog width="35%" v-model="dialog" persistent>
    <v-card>
      <v-card-title> Delete {{ groupInfo.groupName }} </v-card-title>
      <v-card-text>
        Are you sure you want to delete {{ groupInfo.groupName }}?
        <div v-if="groupInfo.lastItemSources.length > 0" style="margin-top: 25px">
            <v-alert
              text
              type="warning"
              border="left">
              <p>Groups/stores from the following divisions will no longer have eligible items applied:</p>
              <p><strong>{{ groupInfo.lastItemSources.join(', ') }}</strong></p>
            </v-alert>
          </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="deleting" @click="$emit('close')">Cancel</v-btn>
        <v-btn
          :loading="deleting"
          @click="deletePromoItemGroup">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayAlert } from '@/mixins/alert'
import PromoItemGroup from "@/axios/promotion-item-group-endpoint"
export default {
  name: "deletePromoItemGroup",
  props: {
    groupInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      deleting: false
    }
  },
  mixins: [displayAlert],
  mounted () {
    this.dialog = true
  },
  methods: {
    async deletePromoItemGroup() {
      this.deleting = true
      try {
        await PromoItemGroup.deletePromoItemGroup(this.groupInfo.groupId)
        this.$emit("update")
        this.$emit("close")
      } catch (err) {
        this.handleError(err)
      } finally {
        this.deleting = false
      }
    }
  }
}
</script>